import $ from 'jquery';
import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;
require("scrolltofixed")
require("@fancyapps/fancybox")

$('[data-fancybox]').fancybox({
    smallBtn: true,
    touch: false,
    btnTpl: {
        smallBtn: '<div class="container"><div class="row"><div class="col-16"><button data-fancybox-close class="fancybox-close-small" title="{{CLOSE}}"><svg viewBox="0 0 32 32"><path d="M10,10 L22,22 M22,10 L10,22"></path></svg></button></div></div></div>',
    },
})